<div class="instrument-errors-container">
  <div class="bpx-section" *ngIf="instrumentStatus$ | async as instruments">
    <div class="bpx-section__head">
      <h3 class="bpx-section__title">Instrument Error Rates</h3>
    </div>
    <div class="bpx-table instrument-errors-table-wrap">
      <table mat-table [dataSource]="instruments" class="mat-elevation-z0">
        <ng-container matColumnDef="instrumentId">
          <th mat-header-cell *matHeaderCellDef>Instrument ID</th>
          <td mat-cell *matCellDef="let element">{{ element.instrumentId }}</td>
        </ng-container>

        <ng-container matColumnDef="percentTotalErrors">
          <th mat-header-cell *matHeaderCellDef>Percent Total Errors</th>
          <td mat-cell *matCellDef="let element">{{ displayAsPercent(element.percentTotalErrors, 100) }}</td>
        </ng-container>

        <ng-container matColumnDef="percentTrueErrors">
          <th mat-header-cell *matHeaderCellDef>Percent True Errors</th>
          <td mat-cell *matCellDef="let element">
            {{ displayAsPercent(element.percentTrueErrors, 100) }}
            @if (isBreachingInstrument(element)) {
              <span class="threshold-flag" title="Above the 10% run quality threshold">&#9888;</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="percentFalseErrors">
          <th mat-header-cell *matHeaderCellDef>Percent False Errors</th>
          <td mat-cell *matCellDef="let element">{{ displayAsPercent(element.percentFalseErrors, 100) }}</td>
        </ng-container>

        <ng-container matColumnDef="isbDrift">
          <th mat-header-cell *matHeaderCellDef>ISB Drift</th>
          <td mat-cell *matCellDef="let element">{{ displayAsPercent(element.isbDrift, 1) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{ 'threshold-breach-row': isBreachingInstrument(row) }"></tr>
      </table>
      @if (!instruments.length) {
        <p class="bpx-empty">No instrument error rates are available for the current calculation.</p>
      }
    </div>
  </div>

  <div class="bpx-section auto-discarded-section">
    <div class="bpx-section__head">
      <h3 class="bpx-section__title">Discarded Replicates</h3>
    </div>
    @if (discardWarningSummary$ | async; as summary) {
      @if (summary.discardBreaches.length) {
        <p class="auto-discarded-total">
          <strong>{{ summary.totalDiscarded }}</strong> of <strong>{{ summary.totalAnalyzed }}</strong>
          replicates analyzed were discarded
          (<strong>{{ displayAsPercent(summary.totalDiscardedFraction, 100) }}</strong> of the study).
        </p>
        <p class="auto-discarded-note">
          More than 10% of replicates were discarded for the following:
        </p>
        <div class="bpx-table instrument-errors-table-wrap">
          <table mat-table [dataSource]="summary.discardBreaches" class="mat-elevation-z0">
            <ng-container matColumnDef="kitLot">
              <th mat-header-cell *matHeaderCellDef>Kit Lot</th>
              <td mat-cell *matCellDef="let element">{{ element.kitLot }}</td>
            </ng-container>

            <ng-container matColumnDef="instrumentId">
              <th mat-header-cell *matHeaderCellDef>Instrument</th>
              <td mat-cell *matCellDef="let element">{{ element.instrumentId }}</td>
            </ng-container>

            <ng-container matColumnDef="beadRegion">
              <th mat-header-cell *matHeaderCellDef>Bead Region</th>
              <td mat-cell *matCellDef="let element">{{ element.beadRegion }}</td>
            </ng-container>

            <ng-container matColumnDef="discardedCount">
              <th mat-header-cell *matHeaderCellDef>Discarded</th>
              <td mat-cell *matCellDef="let element">{{ element.discardedCount }}</td>
            </ng-container>

            <ng-container matColumnDef="analyzedCount">
              <th mat-header-cell *matHeaderCellDef>Analyzed</th>
              <td mat-cell *matCellDef="let element">{{ element.analyzedCount }}</td>
            </ng-container>

            <ng-container matColumnDef="discardedFraction">
              <th mat-header-cell *matHeaderCellDef>Percent</th>
              <td mat-cell *matCellDef="let element">{{ displayAsPercent(element.discardedFraction, 100) }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="discardedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: discardedColumns"></tr>
          </table>
        </div>
      } @else {
        <p class="auto-discarded-empty">No assay exceeded the 10% discarded replicate threshold.</p>
      }
    } @else {
      <p class="auto-discarded-empty">No assay exceeded the 10% discarded replicate threshold.</p>
    }
    <p class="auto-discarded-note">
      Discard reasons for individual replicates are listed on the Calculations tab.
    </p>
  </div>
</div>
